import { render } from "./ContentFieldEditor.vue?vue&type=template&id=3cf9b09a&scoped=true&ts=true"
import script from "./ContentFieldEditor.vue?vue&type=script&lang=ts"
export * from "./ContentFieldEditor.vue?vue&type=script&lang=ts"

import "./ContentFieldEditor.vue?vue&type=style&index=0&id=3cf9b09a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf9b09a"]])

export default __exports__